import { Observable } from 'rxjs';

export abstract class NgRefreshService {
    abstract status: Observable<boolean>;
    abstract refresh(): void;
}
